<template>
  <div id="wrap-drawer">

    <!-- Article info -->
    <div id="doc-info">
      <document-info></document-info>
    </div>

  </div>
</template>

<script>
import { coloring } from "../../../custom/fn_color"

export default {
  data() {
    return {
      list_btn: false
    }
  },

  computed: {

    proj_id() {
      return this.$route.params.id
    },

    doc_key() {
      return this.$route.query.doc
    },

  },

  watch: {
    doc_key: {
      async handler(val) {
        await this.getDocument()
      },
      immediate: true,
    },
  },

  methods: {
    coloring,
    async getDocument() {
      // TODO: error handling
      await this.$store.dispatch('document/getDocument', this.doc_key)
    }
  }
}
</script>

<style scoped>
  #wrap-drawer {
    width: 100%;
    height: calc(100vh - 60px - 60px);
  }

  #wrap-content {
    display: flex;
    flex-direction: column;
  }

  #doc-info {
    height: calc(100vh - 60px - 60px);
    overflow-y: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared_components/drawer/Drawer-Doc.vue